import { createSelector } from 'reselect';
import { RootState } from "../state";

export const selectInsightsState = (state: RootState) => state.insights;

export const selectInsightsData = createSelector(
  selectInsightsState,
  (state) => state?.data
);

export const selectInsightsFilter = createSelector(
  selectInsightsState,
  (state) => state?.filter
);

export const selectLoadingInsightsStatus = createSelector(
  selectInsightsState,
  (state) => state?.isLoading,
)

export const selectLoadedInsightsStatus = createSelector(
  selectInsightsState,
  (state) => state?.loaded,
)

export const selectErrorInsightsStatus = createSelector(
  selectInsightsState,
  (state) => state?.error,
)
